import * as d3 from 'd3'
export default {
  methods: {

    gauge_Router() {

      let angle = this.angle
      let circle = this.circle

      let gauge = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.circle.cx},${this.circle.cy})`)

      var arcBg = d3.arc()
      .innerRadius(circle.radius)
      .outerRadius(circle.radius - circle.tickness)
      .startAngle(angle.start * Math.PI / 180)
      .endAngle(angle.end * Math.PI / 180)

      // ForeGround
      gauge
      .append('path')
      .attr('d', arcBg)
      .attr('fill', `url(#${this.localId}_BP_V2)`)
      .attr('transform', `translate(${0}, ${0})`).attr('opacity', 1)

      this.gauge_Grid() 

      this.draw_WhiteGrid()
      this.gauge_Actual()
      this.draw_WhiteGrid()

      this.gauge_Plan()
      this.gauge_Delta()
    },

    gauge_Grid() {
      let angle = this.angle

      let grid = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.circle.cx},${this.circle.cy})`)

      let i = 0
      for (var n = angle.start; n <= angle.end; n += angle.count) {
        i += 1
        grid
        .append('polygon')
        .attr('points', ()=>{
          if(i==1 || i==26 || i ==52) return `-.7, ${angle.gridY[0]} .7, ${angle.gridY[0]} .4,${angle.gridY[2]} -.4,${angle.gridY[2]}`
          else return `-.7, ${angle.gridY[0]} .7, ${angle.gridY[0]} .4,${angle.gridY[1]} -.4,${angle.gridY[1]}`
        })
        .attr('fill', '#bcbcbc')
        .attr('transform', () => `rotate(${n+1.7}, 0, 0)`)
      }

      grid
      .append('text')
      .attr('transform', `translate(0, ${angle.inY + 19})`)
      .style('font-size', 8).attr('fill', '#757575').attr('text-anchor', 'middle')
      .text('50%')

      grid
      .append('text')
      .attr('transform', `translate(${angle.inY + 16}, 2)`)
      .style('font-size', 8).attr('fill', '#757575').attr('text-anchor', 'start')
      .text('0%')

      grid
      .append('text')
      .attr('transform', `translate(${-angle.inY -14}, 2)`)
      .style('font-size', 8).attr('fill', '#757575').attr('text-anchor', 'end')
      .text('100%')
    },


    draw_WhiteGrid() {
      let angle = this.angle
      let whiteGrid = this.canvasForms

      .append('g')
      .attr('transform', `translate(${this.circle.cx},${this.circle.cy})`)

      for (var n = angle.start; n <= angle.end; n += angle.count) {
        whiteGrid
        .append('polygon')
        .attr('points', `-1.5, ${angle.outY-1} 1.5, ${angle.outY-1} 1.15,${angle.inY+1} -1.15,${angle.inY+1}`)
        .attr('fill', 'white')
        .attr('transform', () => `rotate(${n}, 0, 0)`)
      }

    }

    
  }
}